<template>
    <LazyStoryblokBlock :blok="blok" :next-block="nextBlock" />
</template>

<script setup lang="ts">
import { defineAsyncComponent, hydrateOnVisible } from 'vue';

const props = defineProps<{
    blok: any;
    nextBlock?: any;
    rootMargin?: string;
}>();

const LazyStoryblokBlock = defineAsyncComponent({
    loader: () => import('~/storyblok/StoryblokBlock.vue'),
    hydrate: hydrateOnVisible({ rootMargin: props.rootMargin || '400px 0px' }),
});
</script>
